// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
}

.dropdown-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 1000px;
    border: 1px solid var(--filter);
    border-radius: 10px;
    overflow: auto;
    margin: auto;
    margin-bottom: 15px;
}

.title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid var(--filter);
    background-color: var(--form-background);
    padding: 5px 10px;
}
.title > p {
    font-size: 16px;
    font-weight: 700;
}

.title-buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
    min-width: 60%;
}

.filter-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 34px;
    width: 34px;
    line-height: 34px;
    border: 1px solid var(--terciary-font);
    background-color: var(--screen-background);
}

.product-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
}
.product-list.show {
    max-height: 600px;
    overflow: auto;
}

.product {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
}

.filter-name,
.filter-title,
.product-name {
    font-size: 14px;
    font-weight: 700;
}

.product-grid-info {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: 1fr auto;
    gap: 10px;
    color: var(--text);
}

.product-grid-info > .img {
    height: 90px;
    width: 90px;
    grid-row: 1 / 3;
    text-align: center;
}

.prod-img{
    max-width: 90px;
    max-height: 90px;
}

.packaging {
    grid-column: 2 / 4;
    grid-row: 2 / 3;
    font-size: 11px;
}

.packaging-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
}

.eco-financial-icons,
.box-new-icon {
    width: 1rem;
    color: var(--text);
}

::ng-deep .eco-financial-icons .border,
::ng-deep .eco-financial-icons .text,
::ng-deep .box-new-icon .text,
::ng-deep .box-new-icon .border {
  color: var(--text);
}

::ng-deep .box-new-icon .background,
::ng-deep .eco-financial-icons .background {
  color: transparent;
}

.product-flex-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
    color: var(--text);
}

.product-price {
    display: flex;
    flex-direction: column;
    font-size: 11px;
}

.inner-product-price {
    display: flex;
    align-items: center;
    gap: .2rem;
    font-size: 12px;
}

.starting-at {
    font-size: 8px;
    font-weight: normal;
}

.product-store {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 10px;
}

.product-store-name{
    max-width: 140px;
}

.product-store-link {
    text-decoration: underline !important;
    cursor: pointer;
}

.filters {
    background-color: var(--form-background);
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    padding: 10px 20px;
}

.filter {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.filter-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.filter-title {
    flex-grow: 1;
    text-align: right;
}

.filter-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.filter-item {
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: 100%;
    background-color: var(--screen-background);
    border-radius: 10px 0 10px 10px;
}

.filter-item img {
    max-width: 90px;
    border-radius: 10px 0 10px 10px;
}

.filter-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    margin: 5px;
}

.filter-description {
    font-size: 12px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis; /* ... no final */
}

.button-close {
    color: var(--text);
    width: auto !important;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 18px !important
}

.button-choose {
    font-size: 14px;
    background-color: var(--primary-background);
    color: var(--primary-font) !important;
    width: 75px;
    height: 25px;
    border-radius: 60px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.botao-selected {
    justify-content: center;
    width: 75px;
    height: 25px;
    font-size: 14px;
    color: #fff !important;
    border-radius: 60px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: var(--accept-selection) !important;
}

.complementar {
    text-transform: lowercase;
    font-size: 12px;
    background-color: var(--form-background);
    padding: 5px 10px;
}

.loadMore {
    width: 100%;
    text-align: center;
    border-top: 1px solid var(--filter);
}

.loadMore > button {
    font-size: 11px;
    font-weight: 500;
    text-decoration: underline;
}

.disabled {
    opacity: 50%;
}

.search-bar {
    display: flex;
    justify-content: center;
    width: 100%;
}

.products-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
}

.products-grid > *:not(:nth-child(3n)) {
    border-right: 1px solid var(--filter);
}

.products-grid  > * {
    border-bottom: 1px solid var(--filter);
}

.products-grid > *:nth-last-child(1):nth-child(3n),
.products-grid > *:nth-last-child(2):nth-child(3n-1),
.products-grid > *:nth-last-child(3):nth-child(3n-2),
.products-grid > *:nth-last-child(1):nth-child(3n-1),
.products-grid > *:nth-last-child(2):nth-child(3n-2),
.products-grid > *:nth-last-child(1):nth-child(3n-2) {
    border-bottom: none;
}

.no-product {
    color: var(--text);
    margin: 0 auto;
    padding: 30px 0;
    font-size: 14px;
    -webkit-user-select: none;
            user-select: none;
}

.search-bar .search-block{
    background-color: var(--form-background) !important;
}
.search-bar input{
    background-color: var(--form-background) !important;
}

@media (min-width: 769px) and (max-width: 1000px) {
    .title-buttons {
        min-width: 70%
    }
    .products-grid {
        grid-template-columns: 1fr 1fr;
    }

    .products-grid > *:not(:nth-child(3n)) {
        border-right: none;
    }
    .products-grid > *:not(:nth-child(2n)) {
        border-right: 1px solid var(--filter);
    }

    .products-grid > *:nth-last-child(1):nth-child(3n),
    .products-grid > *:nth-last-child(2):nth-child(3n-1),
    .products-grid > *:nth-last-child(3):nth-child(3n-2),
    .products-grid > *:nth-last-child(1):nth-child(3n-1),
    .products-grid > *:nth-last-child(2):nth-child(3n-2),
    .products-grid > *:nth-last-child(1):nth-child(3n-2) {
        border-bottom: 1px solid var(--filter);
    }

    .products-grid > .product:nth-last-child(1):nth-child(2n),
    .products-grid > .product:nth-last-child(2):nth-child(2n-1),
    .products-grid > .product:nth-last-child(1):nth-child(2n-1) {
        border-bottom: none;
    }
}

@media (max-width: 768px) {
    .products-grid {
        grid-template-columns: 1fr;
    }
    .products-grid > .product {
        border-right: none;
    }
    .products-grid > .product:not(:last-child) {
        border-bottom: 1px solid var(--filter);
    }

    .title-buttons {
        min-width: 100%;
    }

    .filter-option{
      position: relative;
    }

    .mat-radio-button{
      position: absolute;
      top: 5px;
      right: 0px;
    }

    .filter-texts{
      display: flex;
      flex-direction: column;
      align-items: right;
      justify-content: center;
      width: 100%;
    }

}
`, "",{"version":3,"sources":["webpack://./src/app/shared/product-dropdown/product-dropdown.component.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,sCAAsC;IACtC,wCAAwC;IACxC,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,sCAAsC;IACtC,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,uCAAuC;AAC3C;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;AACjB;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,4BAA4B;IAC5B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,uBAAuB,EAAE,iBAAiB;AAC9C;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,2CAA2C;IAC3C,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,oDAAoD;AACxD;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;;;;;IAMI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,mDAAmD;AACvD;AACA;IACI,mDAAmD;AACvD;;AAEA;IACI;QACI;IACJ;IACA;QACI,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;IACtB;IACA;QACI,qCAAqC;IACzC;;IAEA;;;;;;QAMI,sCAAsC;IAC1C;;IAEA;;;QAGI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,sCAAsC;IAC1C;;IAEA;QACI,eAAe;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,UAAU;IACZ;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,kBAAkB;MAClB,uBAAuB;MACvB,WAAW;IACb;;AAEJ","sourcesContent":["* {\n    margin: 0;\n}\n\n.dropdown-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    max-width: 1000px;\n    border: 1px solid var(--filter);\n    border-radius: 10px;\n    overflow: auto;\n    margin: auto;\n    margin-bottom: 15px;\n}\n\n.title {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    border-bottom: 1px solid var(--filter);\n    background-color: var(--form-background);\n    padding: 5px 10px;\n}\n.title > p {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.title-buttons {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 15px;\n    min-width: 60%;\n}\n\n.filter-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 34px;\n    width: 34px;\n    line-height: 34px;\n    border: 1px solid var(--terciary-font);\n    background-color: var(--screen-background);\n}\n\n.product-list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease-in-out;\n}\n.product-list.show {\n    max-height: 600px;\n    overflow: auto;\n}\n\n.product {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    padding: 10px;\n}\n\n.filter-name,\n.filter-title,\n.product-name {\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.product-grid-info {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    grid-template-rows: 1fr auto;\n    gap: 10px;\n    color: var(--text);\n}\n\n.product-grid-info > .img {\n    height: 90px;\n    width: 90px;\n    grid-row: 1 / 3;\n    text-align: center;\n}\n\n.prod-img{\n    max-width: 90px;\n    max-height: 90px;\n}\n\n.packaging {\n    grid-column: 2 / 4;\n    grid-row: 2 / 3;\n    font-size: 11px;\n}\n\n.packaging-info {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n}\n\n.eco-financial-icons,\n.box-new-icon {\n    width: 1rem;\n    color: var(--text);\n}\n\n::ng-deep .eco-financial-icons .border,\n::ng-deep .eco-financial-icons .text,\n::ng-deep .box-new-icon .text,\n::ng-deep .box-new-icon .border {\n  color: var(--text);\n}\n\n::ng-deep .box-new-icon .background,\n::ng-deep .eco-financial-icons .background {\n  color: transparent;\n}\n\n.product-flex-info {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 10px;\n    color: var(--text);\n}\n\n.product-price {\n    display: flex;\n    flex-direction: column;\n    font-size: 11px;\n}\n\n.inner-product-price {\n    display: flex;\n    align-items: center;\n    gap: .2rem;\n    font-size: 12px;\n}\n\n.starting-at {\n    font-size: 8px;\n    font-weight: normal;\n}\n\n.product-store {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    font-size: 10px;\n}\n\n.product-store-name{\n    max-width: 140px;\n}\n\n.product-store-link {\n    text-decoration: underline !important;\n    cursor: pointer;\n}\n\n.filters {\n    background-color: var(--form-background);\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: center;\n    padding: 10px 20px;\n}\n\n.filter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    gap: 10px;\n}\n\n.filter-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.filter-title {\n    flex-grow: 1;\n    text-align: right;\n}\n\n.filter-option {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n}\n\n.filter-item {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    width: 100%;\n    background-color: var(--screen-background);\n    border-radius: 10px 0 10px 10px;\n}\n\n.filter-item img {\n    max-width: 90px;\n    border-radius: 10px 0 10px 10px;\n}\n\n.filter-info {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 5px;\n    margin: 5px;\n}\n\n.filter-description {\n    font-size: 12px;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 3;\n    line-clamp: 3;\n    overflow: hidden;\n    text-overflow: ellipsis; /* ... no final */\n}\n\n.button-close {\n    color: var(--text);\n    width: auto !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 18px !important\n}\n\n.button-choose {\n    font-size: 14px;\n    background-color: var(--primary-background);\n    color: var(--primary-font) !important;\n    width: 75px;\n    height: 25px;\n    border-radius: 60px;\n    padding: 0 10px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.botao-selected {\n    justify-content: center;\n    width: 75px;\n    height: 25px;\n    font-size: 14px;\n    color: #fff !important;\n    border-radius: 60px;\n    padding: 0 10px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    background-color: var(--accept-selection) !important;\n}\n\n.complementar {\n    text-transform: lowercase;\n    font-size: 12px;\n    background-color: var(--form-background);\n    padding: 5px 10px;\n}\n\n.loadMore {\n    width: 100%;\n    text-align: center;\n    border-top: 1px solid var(--filter);\n}\n\n.loadMore > button {\n    font-size: 11px;\n    font-weight: 500;\n    text-decoration: underline;\n}\n\n.disabled {\n    opacity: 50%;\n}\n\n.search-bar {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.products-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    width: 100%;\n}\n\n.products-grid > *:not(:nth-child(3n)) {\n    border-right: 1px solid var(--filter);\n}\n\n.products-grid  > * {\n    border-bottom: 1px solid var(--filter);\n}\n\n.products-grid > *:nth-last-child(1):nth-child(3n),\n.products-grid > *:nth-last-child(2):nth-child(3n-1),\n.products-grid > *:nth-last-child(3):nth-child(3n-2),\n.products-grid > *:nth-last-child(1):nth-child(3n-1),\n.products-grid > *:nth-last-child(2):nth-child(3n-2),\n.products-grid > *:nth-last-child(1):nth-child(3n-2) {\n    border-bottom: none;\n}\n\n.no-product {\n    color: var(--text);\n    margin: 0 auto;\n    padding: 30px 0;\n    font-size: 14px;\n    user-select: none;\n}\n\n.search-bar .search-block{\n    background-color: var(--form-background) !important;\n}\n.search-bar input{\n    background-color: var(--form-background) !important;\n}\n\n@media (min-width: 769px) and (max-width: 1000px) {\n    .title-buttons {\n        min-width: 70%\n    }\n    .products-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .products-grid > *:not(:nth-child(3n)) {\n        border-right: none;\n    }\n    .products-grid > *:not(:nth-child(2n)) {\n        border-right: 1px solid var(--filter);\n    }\n\n    .products-grid > *:nth-last-child(1):nth-child(3n),\n    .products-grid > *:nth-last-child(2):nth-child(3n-1),\n    .products-grid > *:nth-last-child(3):nth-child(3n-2),\n    .products-grid > *:nth-last-child(1):nth-child(3n-1),\n    .products-grid > *:nth-last-child(2):nth-child(3n-2),\n    .products-grid > *:nth-last-child(1):nth-child(3n-2) {\n        border-bottom: 1px solid var(--filter);\n    }\n\n    .products-grid > .product:nth-last-child(1):nth-child(2n),\n    .products-grid > .product:nth-last-child(2):nth-child(2n-1),\n    .products-grid > .product:nth-last-child(1):nth-child(2n-1) {\n        border-bottom: none;\n    }\n}\n\n@media (max-width: 768px) {\n    .products-grid {\n        grid-template-columns: 1fr;\n    }\n    .products-grid > .product {\n        border-right: none;\n    }\n    .products-grid > .product:not(:last-child) {\n        border-bottom: 1px solid var(--filter);\n    }\n\n    .title-buttons {\n        min-width: 100%;\n    }\n\n    .filter-option{\n      position: relative;\n    }\n\n    .mat-radio-button{\n      position: absolute;\n      top: 5px;\n      right: 0px;\n    }\n\n    .filter-texts{\n      display: flex;\n      flex-direction: column;\n      align-items: right;\n      justify-content: center;\n      width: 100%;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
